import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _repeatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/repeat";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Number$isNaN from "@babel/runtime-corejs3/core-js-stable/number/is-nan";
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import mapValues from "lodash/mapValues";
import map from "lodash/fp/map";
import styles from "./Grid.module.css";
import { useBreakpoint } from '../breakpoint/useBreakpoint';
const mapToFraction = map(el => _Number$isNaN(Number(el)) ? el : `${el}fr`);
export const gaps = {
  none: 'None',
  small: 'Small',
  medium: 'Medium',
  large: 'Large'
};
const vgapMapping = mapValues(gaps, type => styles[`vgap${type}`]);
const hgapMapping = mapValues(gaps, type => styles[`hgap${type}`]);
const alignments = {
  top: 'Start',
  middle: 'Center',
  bottom: 'End',
  baseline: 'Baseline',
  stretch: 'Stretch'
};
export const gridAlignments = _Object$keys(alignments);
const valignItemsMapping = mapValues(alignments, type => styles[`alignItems${type}`]);
const valignContentMapping = mapValues(alignments, type => styles[`alignContent${type}`]);
const justifications = {
  left: 'Start',
  center: 'Center',
  right: 'End',
  around: 'Around',
  between: 'Between',
  evenly: 'Evenly',
  stretch: 'Stretch'
};
const justifyItemsMapping = mapValues(justifications, type => styles[`justifyItems${type}`]);
const justifyContentMapping = mapValues(justifications, type => styles[`justifyContent${type}`]);
export let styleMappings = null;
if (window.__TEST__) {
  styleMappings = {
    vgap: vgapMapping,
    hgap: hgapMapping,
    alignItems: valignItemsMapping,
    alignContent: valignContentMapping,
    justifyItems: justifyItemsMapping,
    justifyContent: justifyContentMapping
  };
}
export const Grid = props => {
  const _useBreakpoint = useBreakpoint(props),
    breakpointProps = _useBreakpoint.breakpointProps;
  const columnsProp = breakpointProps.columns,
    repeat = _repeatInstanceProperty(breakpointProps),
    rowsProp = breakpointProps.rows,
    autoRows = breakpointProps.autoRows,
    gap = breakpointProps.gap,
    _breakpointProps$vgap = breakpointProps.vgap,
    vgap = _breakpointProps$vgap === void 0 ? gap : _breakpointProps$vgap,
    _breakpointProps$hgap = breakpointProps.hgap,
    hgap = _breakpointProps$hgap === void 0 ? gap : _breakpointProps$hgap,
    justifyContent = breakpointProps.justifyContent,
    valignContent = breakpointProps.valignContent,
    justifyItems = breakpointProps.justifyItems,
    valignItems = breakpointProps.valignItems,
    tag = breakpointProps.tag,
    children = breakpointProps.children,
    className = breakpointProps.className,
    blockPointerEvents = breakpointProps.blockPointerEvents,
    style = breakpointProps.style,
    phone = breakpointProps.phone,
    phoneWide = breakpointProps.phoneWide,
    tablet = breakpointProps.tablet,
    dangerouslySetInnerHTML = breakpointProps.dangerouslySetInnerHTML,
    other = _objectWithoutProperties(breakpointProps, ["columns", "repeat", "rows", "autoRows", "gap", "vgap", "hgap", "justifyContent", "valignContent", "justifyItems", "valignItems", "tag", "children", "className", "blockPointerEvents", "style", "phone", "phoneWide", "tablet", "dangerouslySetInnerHTML"]);
  const columns = mapToFraction(columnsProp);
  const rows = mapToFraction(rowsProp);
  const vgapClass = vgap && vgapMapping[vgap];
  const hgapClass = hgap && hgapMapping[hgap];
  const valignContentClass = valignContent && valignContentMapping[valignContent];
  const justifyContentClass = justifyContent && justifyContentMapping[justifyContent];
  const valignItemsClass = valignItems && valignItemsMapping[valignItems];
  const justifyItemsClass = justifyItems && justifyItemsMapping[justifyItems];
  const classes = cx(styles.grid, vgapClass, hgapClass, valignContentClass, justifyContentClass, valignItemsClass, justifyItemsClass, className);
  let hasHiddenColumns = false;
  let gridColumns;
  if (columns) {
    if (repeat) {
      gridColumns = `repeat(${repeat}, ${columns.join(' ')}`;
    } else {
      const filteredColumns = _filterInstanceProperty(columns).call(columns, column => column !== '0fr');
      gridColumns = filteredColumns.join(' ');
      hasHiddenColumns = columns.length !== filteredColumns.length;
    }
  }
  let gridRows;
  if (rows) {
    gridRows = rows.join(' ');
  }
  let gridAutoRows;
  if (autoRows) {
    gridAutoRows = autoRows.join(' ');
  }
  const inlineStyles = _objectSpread({}, style);
  if (gridColumns || gridRows || gridAutoRows) {
    if (gridColumns) {
      inlineStyles.gridTemplateColumns = gridColumns;
    }
    if (gridRows) {
      inlineStyles.gridTemplateRows = gridRows;
    }
    if (gridAutoRows) {
      inlineStyles.gridAutoRows = gridAutoRows;
    }
    if (blockPointerEvents) {
      inlineStyles.pointerEvents = 'none';
    }
  }
  let realChildren = children;
  if (hasHiddenColumns && columns) {
    var _context;
    const colLength = columns.length;
    realChildren = _mapInstanceProperty(_context = React.Children).call(_context, children, (child, index) => {
      const colIndex = index % colLength;
      return columns[colIndex] !== '0fr' ? child : null;
    });
  }
  const Tag = tag;
  return React.createElement(Tag, _extends({
    className: classes,
    style: inlineStyles
  }, other), realChildren);
};
export const gridPropTypes = {
  columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
  repeat: PropTypes.oneOfType([PropTypes.oneOf(['auto-fit', 'auto-fill']), PropTypes.number, PropTypes.string]),
  rows: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
  autoRows: PropTypes.array,
  gap: PropTypes.oneOf(_Object$keys(gaps)),
  hgap: PropTypes.oneOf(_Object$keys(gaps)),
  vgap: PropTypes.oneOf(_Object$keys(gaps)),
  valignContent: PropTypes.oneOf(gridAlignments),
  justifyContent: PropTypes.oneOf(_Object$keys(justifications)),
  valignItems: PropTypes.oneOf(gridAlignments),
  justifyItems: PropTypes.oneOf(_Object$keys(justifications)),
  tag: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
  phone: PropTypes.object,
  phoneWide: PropTypes.object,
  tablet: PropTypes.object,
  blockPointerEvents: PropTypes.bool
};
Grid.propTypes = gridPropTypes;
Grid.defaultProps = {
  gap: 'medium',
  tag: 'div'
};
Grid.displayName = 'Grid';
Grid.__docgenInfo = {
  componentName: "Grid",
  packageName: "@jutro/layout",
  description: "Renders a css grid. For each grid item, place its children in an Jutro `GridItem`.",
  displayName: "Grid",
  methods: [],
  actualName: "Grid",
  metadataType: "layout",
  props: {
    columns: {
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "string"
          }, {
            name: "number"
          }]
        }
      },
      required: false,
      description: "Define explicit columns widths"
    },
    repeat: {
      type: {
        name: "union",
        value: [{
          name: "enum",
          value: [{
            value: "'auto-fit'",
            computed: false
          }, {
            value: "'auto-fill'",
            computed: false
          }]
        }, {
          name: "number"
        }, {
          name: "string"
        }]
      },
      required: false,
      description: "Repeat columns"
    },
    rows: {
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "string"
          }, {
            name: "number"
          }]
        }
      },
      required: false,
      description: "Define explicit rows heights"
    },
    autoRows: {
      type: {
        name: "array"
      },
      required: false,
      description: "Define implicit rows"
    },
    gap: {
      type: {
        name: "enum",
        value: [{
          value: "\"none\"",
          computed: false
        }, {
          value: "\"small\"",
          computed: false
        }, {
          value: "\"medium\"",
          computed: false
        }, {
          value: "\"large\"",
          computed: false
        }]
      },
      required: false,
      description: "Gap between rows and columns ('none', 'small', 'medium', 'large')",
      defaultValue: {
        value: "'medium'",
        computed: false
      }
    },
    hgap: {
      type: {
        name: "enum",
        value: [{
          value: "\"none\"",
          computed: false
        }, {
          value: "\"small\"",
          computed: false
        }, {
          value: "\"medium\"",
          computed: false
        }, {
          value: "\"large\"",
          computed: false
        }]
      },
      required: false,
      description: "Gap between columns ('none', 'small', 'medium', 'large')\nIf unspecified, will fallback to 'gap' property."
    },
    vgap: {
      type: {
        name: "enum",
        value: [{
          value: "\"none\"",
          computed: false
        }, {
          value: "\"small\"",
          computed: false
        }, {
          value: "\"medium\"",
          computed: false
        }, {
          value: "\"large\"",
          computed: false
        }]
      },
      required: false,
      description: "Gap between rows ('none', 'small', 'medium', 'large')\nIf unspecified, will fallback to 'gap' property."
    },
    valignContent: {
      type: {
        name: "enum",
        value: [{
          value: "\"top\"",
          computed: false
        }, {
          value: "\"middle\"",
          computed: false
        }, {
          value: "\"bottom\"",
          computed: false
        }, {
          value: "\"baseline\"",
          computed: false
        }, {
          value: "\"stretch\"",
          computed: false
        }]
      },
      required: false,
      description: "Vertical align the grid within its container; default - 'stretch'"
    },
    justifyContent: {
      type: {
        name: "enum",
        value: [{
          value: "\"left\"",
          computed: false
        }, {
          value: "\"center\"",
          computed: false
        }, {
          value: "\"right\"",
          computed: false
        }, {
          value: "\"around\"",
          computed: false
        }, {
          value: "\"between\"",
          computed: false
        }, {
          value: "\"evenly\"",
          computed: false
        }, {
          value: "\"stretch\"",
          computed: false
        }]
      },
      required: false,
      description: "Justify the grid within its container (left, center, right, around, between, evenly)"
    },
    valignItems: {
      type: {
        name: "enum",
        value: [{
          value: "\"top\"",
          computed: false
        }, {
          value: "\"middle\"",
          computed: false
        }, {
          value: "\"bottom\"",
          computed: false
        }, {
          value: "\"baseline\"",
          computed: false
        }, {
          value: "\"stretch\"",
          computed: false
        }]
      },
      required: false,
      description: "Vertical align all items within the grid; default - 'stretch'"
    },
    justifyItems: {
      type: {
        name: "enum",
        value: [{
          value: "\"left\"",
          computed: false
        }, {
          value: "\"center\"",
          computed: false
        }, {
          value: "\"right\"",
          computed: false
        }, {
          value: "\"around\"",
          computed: false
        }, {
          value: "\"between\"",
          computed: false
        }, {
          value: "\"evenly\"",
          computed: false
        }, {
          value: "\"stretch\"",
          computed: false
        }]
      },
      required: false,
      description: "Justify all items within the grid (left, center, right, around, between, evenly)"
    },
    tag: {
      type: {
        name: "elementType"
      },
      required: false,
      description: "Optional dom tag to render",
      defaultValue: {
        value: "'div'",
        computed: false
      }
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Optional css class(es) to add to the grid tag"
    },
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: "Children; preferably 'GridItem'; works with any child"
    },
    style: {
      type: {
        name: "object"
      },
      required: false,
      description: "DOM element styles"
    },
    phone: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any Grid property for use at 'phone' breakpoint"
    },
    phoneWide: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any Grid property for use at 'phoneWide' breakpoint"
    },
    tablet: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any Grid property for use at 'tablet' and 'phone' breakpoint;"
    },
    blockPointerEvents: {
      type: {
        name: "bool"
      },
      required: false,
      description: ""
    }
  }
};